module.exports = __webpack_public_path__ + "img/au.013b1790.svg";